import React, { useEffect, useRef, useState } from 'react';
import CardWrapper from '../CardWrapper';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAppUsageDetails, appUsageSelector } from '../AnalyticsSlice';
//temporarily disable
// import zc from "@dvsl/zoomcharts";
import PreArrival from '../digital-check-in/Pre-Arrival';
import SummaryCardWrapper from '../SummaryCardWrapper';
import { isEmpty } from 'lodash';
import { addDays } from 'date-fns';
import './App-Usage.scss';
import moment from 'moment/moment';
import WaveCard from '../../../shared/wave-card/WaveCard';
import CustomPieChart from '../../../shared/charts/custom-pie-chart/CustomPieChart';
import CustomLineChart from '../../../shared/charts/custom-line-chart/CustomLineChart';
import { statisticsDataKeys } from '../Analytics';

const AppUsage = (props) => {
  const { startDate, endDate, hotelId } = props;
  const dispatch = useDispatch();
  const appUsageData = useSelector(appUsageSelector);
  const [countryData, setCountryData] = useState([]);
  const [userEngagementData, setUserEngagementData] = useState([]);
  const [pieChartData, setPieChartData] = useState([]);
  const [barChartData, setBarChartData] = useState([]);

  //temporarily disable
  // let PieChart = zc.PieChart;
  // let TimeChart = zc.TimeChart;

  const [showNoData, setShowNoData] = useState(null);
  const parentElement = useRef(null);

  const updateDataAvailability = () => {
    parentElement.current = document?.getElementById('app-usage-analytics');

    if (
      document?.getElementById('app-usage-analytics1')?.childNodes?.length <= 0 &&
      document?.getElementById('app-usage-analytics2')?.childNodes?.length <= 0
    ) {
      setShowNoData(true);
    } else {
      setShowNoData(false);
    }
  };

  useEffect(() => {
    if (hotelId && startDate && endDate) {
      onFetchUsageData();
    }

    updateDataAvailability();
  }, [hotelId, startDate, endDate]);

  useEffect(() => {
    if (appUsageData?.totalHits && !isEmpty(appUsageData?.totalHits)) {
      let totalHitsChartData = JSON.parse(appUsageData?.totalHits?.pieChartData);

      const data = {
        subvalues: appUsageData?.totalHits?.total !== 0 ? totalHitsChartData : [],
      };

      if (data?.subvalues?.length > 0) {
        setPieChartData(
          data?.subvalues?.map((element, index) => {
            return {
              ...element,
              ...{ Users: element.value },
            };
          }),
        );
      } else {
        setPieChartData([]);
      }
    }
    if (
      !isEmpty(appUsageData?.userStats) &&
      appUsageData?.userStats?.userCountByCountry?.geoGraphData
    ) {
      let appUsageDataList = JSON.parse(appUsageData?.userStats?.userCountByCountry?.geoGraphData);
      let firstItem = appUsageDataList?.shift();

      let userCountByCountryList = appUsageDataList?.map((x) => {
        return [x[0], parseInt(x[1])];
      });

      if (firstItem) {
        userCountByCountryList.unshift(firstItem);
      }

      setCountryData(userCountByCountryList);
    } else {
      setCountryData([]);
    }

    if (
      !isEmpty(appUsageData?.sessionStats) &&
      appUsageData?.sessionStats?.userEngagementBySessions
    ) {
      let userEngagementBySessionsList = JSON.parse(
        appUsageData?.sessionStats?.userEngagementBySessions,
      );

      let sessionData = userEngagementBySessionsList?.map((x) => {
        return [x?.name, x?.value];
      });

      const namesToFilter = ['RNSScreen', 'HamburgerMenu', 'WebViewScreen'];
      sessionData = sessionData?.filter(
        ([name]) => name?.length <= 14 && !namesToFilter?.includes(name),
      );

      const namesToReNamed = {
        LoginModal: 'Login',
        DoAtHotel: 'Hotel Compendium',
        MyProfile: 'Profile Details',
        Welcome: 'Home Page',
      };

      sessionData?.forEach((item) => {
        if (namesToReNamed[item[0]]) {
          item[0] = namesToReNamed[item[0]];
        }
      });

      if (sessionData?.length > 0) {
        sessionData?.unshift(['name', 'value']);
      }
      setUserEngagementData(sessionData);
    } else {
      setUserEngagementData([]);
    }

    updateDataAvailability();
  }, [appUsageData?.totalHits, appUsageData?.userStats]);

  useEffect(() => {
    let lastMonthDataList = [];
    let currentDate = new Date();
    let tempEndDate = currentDate.setDate(currentDate.getDate() + 1);
    let totalHits = '0';
    if (
      !isEmpty(appUsageData?.userStats) &&
      appUsageData?.userStats?.lastMonthStats &&
      appUsageData?.userStats?.lastMonthStats?.dailyUserCount
    ) {
      lastMonthDataList = JSON.parse(appUsageData?.userStats?.lastMonthStats?.dailyUserCount);
      totalHits = appUsageData?.userStats?.lastMonthStats?.formattedTotalUserCount?.toString();
    }

    let barData = [];

    for (let index = 0; index < lastMonthDataList.length; index++) {
      const element = lastMonthDataList[index];

      if (element.length > 1) {
        barData.push({
          [statisticsDataKeys.date]: moment(new Date(element?.[0]) * 1000)?.format(
            statisticsDataKeys.dateFormat,
          ),
          y: Number(element[1]),
          Users: Number(element[1]),
        });
      }
    }

    setBarChartData(
      barData?.sort((chart1, chart2) => {
        return (
          new Date(chart1?.[statisticsDataKeys.date]) - new Date(chart2?.[statisticsDataKeys.date])
        );
      }),
    );

    updateDataAvailability();
  }, [appUsageData?.userStats?.lastMonthStats]);

  const infoContents = (data) => {
    let info = "<div style='height:25px;'>";

    if (data?.label) {
      info +=
        "<p style='padding:5px 10px 8px 10px; text-align: center; font-weight: bold;'>" +
        data.label +
        '</p>';
    } else {
      info += "<p style='padding:5px 10px 8px 10px; text-align: center; font-weight: bold;'>NA</p>";
    }
    info += '</div>';

    return info;
  };

  const onFetchUsageData = () => {
    const payload = {
      hotelId,
      startDate: startDate,
      endDate: endDate,
    };
    dispatch(fetchAppUsageDetails(payload));
  };

  const isPositive = (value) => {
    return value > 0;
  };

  const round = (value, precision) => {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  };

  const generateList = (data, n) => {
    let temp = data?.map((x) => {
      return {
        ...x,
        name: x?.country,
        formattedCount: x?.formattedCount,
        percentage: round(x?.percentage, 1),
      };
    });
    return temp?.slice(0, n);
  };

  useEffect(() => {
    if (countryData) {
      window.google.charts?.load('current', {
        packages: ['geochart'],
      });
      window.google.charts?.setOnLoadCallback(drawRegionsMap);
      function drawRegionsMap() {
        let data = window.google.visualization.arrayToDataTable(
          countryData || [['Country', 'User count']],
        );

        let options = {
          colorAxis: {
            colors: ['#92e6e6', '#0dcccc'],
          },
          keepAspectRatio: true,
          legend: 'none',
        };

        if (document.getElementById('regions_div') !== null) {
          let chart = new window.google.visualization.GeoChart(
            document.getElementById('regions_div'),
          );

          chart.draw(data, options);
        }
      }
    }

    updateDataAvailability();
  }, [countryData, hotelId]);

  useEffect(() => {
    if (userEngagementData) {
      window.google.charts.load('current', {
        packages: ['corechart', 'bar'],
      });
      window.google.charts.setOnLoadCallback(drawRegionsMap);

      function drawRegionsMap() {
        let data = window.google.visualization.arrayToDataTable(
          userEngagementData?.slice(0, 10) || [['name', 'value']],
        );

        let options = {
          chartArea: {
            width: '65%',
            left: 150,
            top: 50,
          },
          colors: ['#0B353F'],
          bar: { groupWidth: '60%' },
          hAxis: {
            minValue: 0,
            format: 'short',
            textStyle: {
              color: '#ABAFB3',
              fontSize: 14,
            },
          },
          vAxis: {
            textStyle: {
              color: '#ABAFB3',
              fontSize: 12,
            },
          },

          legend: { position: 'none' },
        };

        if (document.getElementById('user_eng_div') !== null) {
          let chart = new window.google.visualization.BarChart(
            document.getElementById('user_eng_div'),
          );

          chart.draw(data, options);
        }
      }
    }

    updateDataAvailability();
  }, [userEngagementData, hotelId]);

  return (
    <>
      {showNoData ? (
        <p className='py-3 m-0'>
          Unable to generate reports due to third-party integration limitations.
        </p>
      ) : null}
      <div id='app-usage-analytics'>
        <div
          id='app-usage-analytics1'
          className='app-usage-users-state d-flex gap-4 flex-wrap  py-3'
        >
          <PreArrival
            title='Total Users'
            total={appUsageData?.userStats?.totalUsers?.formattedValue || 0}
            subValue={`${round(appUsageData?.userStats?.totalUsers?.percentage || 0, 1)} %`}
            isUp={isPositive(appUsageData?.userStats?.totalUsers?.percentage || 0)}
            showArrow={true}
            margin='24px 0 0 0'
            showButton={true}
            androidButtonData={appUsageData?.userStats?.androidTotalUsers?.formattedValue || 0}
            iosButtonData={appUsageData?.userStats?.iosTotalUsers?.formattedValue || 0}
            isInformation={'Total number of users'}
          />
          <PreArrival
            title='New Users'
            total={appUsageData?.userStats?.newUsers?.formattedValue || 0}
            subValue={`${round(appUsageData?.userStats?.newUsers?.percentage || 0, 1)} %`}
            isUp={isPositive(appUsageData?.userStats?.newUsers?.percentage || 0)}
            showArrow={true}
            margin='24px 0 0 0'
            showButton={true}
            androidButtonData={appUsageData?.userStats?.androidNewUsers?.formattedValue || 0}
            iosButtonData={appUsageData?.userStats?.iosNewUsers?.formattedValue || 0}
            isInformation={'Total number of new users in the given time frame'}
          />
          {/* Temporary purpose
          <PreArrival
            title="Downloads"
            total={appUsageData?.userStats?.newUsers?.formattedValue || 0}
            subValue={`${round(
              appUsageData?.userStats?.newUsers?.percentage || 0,
              1
            )} %`}
            isUp={isPositive(
              appUsageData?.userStats?.newUsers?.percentage || 0
            )}
            showArrow={true}
            margin="24px 0 0 0"
            showButton={true}
            androidButtonData={
              appUsageData?.userStats?.downloads?.formattedValue || 0
            }
            iosButtonData={
              appUsageData?.userStats?.iosDownloads?.formattedValue || 0
            }
            isInformation={" Total number of app downloads"}
          /> */}
        </div>
        <div id='app-usage-analytics2' className='col-12 d-flex flex-column gap-3 pb-3'>
          {pieChartData?.length > 0 && (
            <CardWrapper
              title='Login'
              isInformation={'Total number of logins in the given time frame'}
              start={startDate}
              end={endDate}
              onClickRefreshBtn={onFetchUsageData}
              isCustom={true}
              width='35%'
              includeWidth={false}
              isRemoveDownload={true}
              className='col-12'
            >
              <div className='text-center col position-relative' style={{ height: '20rem' }}>
                <CustomPieChart data={pieChartData} tooltipItems={['Users']} />
              </div>
            </CardWrapper>
          )}
          {barChartData?.length > 0 && (
            <CardWrapper
              title='Users in last 30 days'
              start={startDate}
              isInformation={'Total number of users in the last 30 days'}
              end={endDate}
              onClickRefreshBtn={onFetchUsageData}
              isCustom={true}
              includeWidth={false}
              isRemoveDownload={true}
              className='col-12'
            >
              <div className='p-2 pt-3 col-12 mw-100'>
                <CustomLineChart
                  xAxis={statisticsDataKeys.date}
                  data={barChartData}
                  sliderX={true}
                  tooltipItems={['Users']}
                />
              </div>
              <WaveCard
                data={generateList(appUsageData?.userStats?.lastMonthStats?.userCountByCountry, 4)}
              />
            </CardWrapper>
          )}
        </div>

        <div id='app-usage-analytics3' className='d-flex flex-row gap-3 flex-wrap pb-3'>
          {countryData?.length > 0 && (
            <CardWrapper
              title='Users by Country'
              isInformation={'Users by country'}
              start={startDate}
              end={endDate}
              onClickRefreshBtn={onFetchUsageData}
              isCustom={true}
              isRemoveDownload={true}
              className={'col-lg-12'}
            >
              <div className='d-flex flex-wrap col-12 p-2'>
                <div
                  id='regions_div'
                  className='col col-lg-12'
                  style={{
                    height: 375,
                    paddingTop: 50,
                  }}
                />

                <WaveCard
                  data={generateList(appUsageData?.userStats?.userCountByCountry?.tableData, 7)}
                />
              </div>
            </CardWrapper>
          )}
          {/*Temporary purpose
            <div className="d-flex justify-content-between flex-wrap">
              <div className="app-usage-session-state">
                
                  <div className="d-flex flex-wrap">
                    <SummaryCardWrapper
                      title="Avg Session Time"
                      total={
                        (appUsageData &&
                          appUsageData?.sessionStats?.averageSessionTime
                            ?.formattedValue) ||
                        0
                      }
                      ird={true}
                      sub1="Mins"
                      sub2={`${round(
                        appUsageData?.sessionStats?.averageSessionTime
                          ?.percentage || 0,
                        0
                      )}mins`}
                      isUp={isPositive(
                        appUsageData?.sessionStats?.averageSessionTime
                          ?.percentage || 0
                      )}
                      marginLeft={true}
                      isInformation={"Avg Time spent on the Application"}
                    />
                    <SummaryCardWrapper
                      title="Avg Session Frequency"
                      isInformation={
                        "Avg frequency of starting the application per day"
                      }
                      total={
                        (appUsageData &&
                          appUsageData?.sessionStats
                            ?.averageSessionFrequency) ||
                        0
                      }
                      ird={true}
                      sub1="Times/day"
                      sub2={""}
                      isUp={false}
                      marginLeft={true}
                    />
                  </div>

                
                  <div className="d-flex flex-wrap">
                    <SummaryCardWrapper
                      title="App Load Time"
                      isInformation={"Time taken to load the application"}
                      total={
                        (appUsageData &&
                          appUsageData?.sessionStats?.appLoadTime
                            ?.formattedValue) ||
                        0
                      }
                      ird={true}
                      sub1="Secs"
                      sub2={`${round(
                        appUsageData?.sessionStats?.appLoadTime?.percentage ||
                          0,
                        0
                      )}secs`}
                      isUp={isPositive(
                        appUsageData?.sessionStats?.averageSessionTime
                          ?.percentage || 0
                      )}
                      marginLeft={true}
                    />
                    <SummaryCardWrapper
                      title="User Engagement"
                      isInformation={"User engagement"}
                      total={
                        (appUsageData &&
                          appUsageData?.sessionStats?.userEngagement
                            ?.formattedValue) ||
                        0
                      }
                      ird={true}
                      sub1=""
                      sub2={`${round(
                        appUsageData?.sessionStats?.userEngagement
                          ?.percentage || 0,
                        0
                      )}%`}
                      isUp={isPositive(
                        appUsageData?.sessionStats?.userEngagement
                          ?.percentage || 0
                      )}
                      marginLeft={true}
                    />
                  </div>
              </div>
              {userEngagementData?.length > 0 && (
                <CardWrapper
                  title="Users Engagement by Sessions"
                  isInformation={"Users engagement by Sessions"}
                  start={startDate}
                  end={endDate}
                  onClickRefreshBtn={onFetchUsageData}
                  isCustom={true}
                  isRemoveDownload={true}
                  includeWidth={false}
                  width="70%"
                >
                  {userEngagementData?.length > 0 && (
                    <div
                      id="user_eng_div"
                      className="ms-2"
                      style={{ height: 375 }}
                    />
                  )}
                </CardWrapper>
              )}
            </div> */}
        </div>
      </div>
    </>
  );
};

export default AppUsage;
